import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IBin } from './bin';
import { catchError, tap, map } from 'rxjs/operators';
import * as myGlobals from '../global';
import { NaturalezaContable } from './naturaleza-contable';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class NaturalezasContableService {
  private _naturalezasContableURL = myGlobals.baseApi + '/webadmin/v1/accountingnature';

  constructor(private http: HttpClientSecured) {}

  allRecords() {
    return this.http.get<any>(this._naturalezasContableURL);
  }

  getAccountingNature(itemid: string): Observable<NaturalezaContable | undefined> {
    return this.allRecords().pipe(map((bines: NaturalezaContable[]) => bines.find(p => p.id === itemid)));
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
